import { useMemo } from 'react';
import { useSSRSelector } from 'src/redux';
import {
  getStoreSubscriptionConditions,
  getWebsiteLiveStatus,
} from 'src/utils/storeSubscriptionConfigs';

export function useStoreSubscriptionConfigs() {
  const storeData = useSSRSelector((store) => store.storeReducer.store);

  const statuses = useMemo(() => {
    return {
      subscriptionStatus: getStoreSubscriptionConditions(storeData),
      websiteStatus: getWebsiteLiveStatus(storeData),
    };
  }, [storeData]);

  return statuses;
}
